
<div>
  <h2 class="text-primary mb-4">{{ templateVersion.attribute_store['short-name'] }}</h2>
  <b-form>
    <b-form-group v-for="category_node in category_nodes" :key="category_node.id"
                  :label="category_node.name"
                  label-class="text-danger font-weight-bold">
      <div :class="{'card border-info':hasPromotionText(category_node)}"
           :style="{true:'border-width: medium'}[hasPromotionText(category_node)]">
        <div :class="{'card-body':hasPromotionText(category_node)}">
          <b-form-select
              v-model="selected_node_id_by_category_node_id[category_node.id]"
              :options="options_by_category_node_id[category_node.id]"
              @change="handleOptionChange(category_node,$event)"
              value-field="id"
              text-field="name"
              required>
          </b-form-select>
          <b-alert variant="info" :show="hasPromotionText(category_node)">{{ promotionText(category_node) }}</b-alert>
        </div>
      </div>
    </b-form-group>
  </b-form>
</div>
